import React from "react";
import { Phone, Instagram } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

const WhatsAppIcon = ({ size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor"><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24z"/></svg>
);

export default function OtherMenus() {
  const { settings } = useSettings();
  const number = settings?.whatsapp || "2348094706281";
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24 text-center">
      <p className="text-sapore-gold uppercase tracking-[0.3em] text-xs mb-3">Other Menus</p>
      <h1 className="font-serif text-4xl sm:text-5xl font-bold text-sapore-purple">Lunch, dinner &amp; more</h1>
      <p className="text-sapore-inkSoft mt-4 max-w-xl mx-auto leading-relaxed">
        Our lunch, dinner, and event menus aren't online yet — but they're available on request. Reach out and our team will share the full selection and pricing.
      </p>
      <div className="flex flex-wrap justify-center gap-3 mt-8">
        <a href={`tel:${settings?.phone || ""}`} data-testid="other-call" className="inline-flex items-center gap-2 bg-sapore-purple text-sapore-cream font-semibold px-6 py-3.5 rounded-full hover:bg-sapore-purpleDark transition-colors">
          <Phone size={18} /> Call
        </a>
        <a href={`https://wa.me/${number}`} target="_blank" rel="noreferrer" data-testid="other-whatsapp" className="inline-flex items-center gap-2 bg-sapore-whatsapp text-white font-semibold px-6 py-3.5 rounded-full hover:bg-sapore-whatsappDark transition-colors">
          <WhatsAppIcon /> WhatsApp
        </a>
        <a href={settings?.instagram || "#"} target="_blank" rel="noreferrer" data-testid="other-instagram" className="inline-flex items-center gap-2 border border-sapore-purple text-sapore-purple font-semibold px-6 py-3.5 rounded-full hover:bg-sapore-goldSubtle transition-colors">
          <Instagram size={18} /> Instagram
        </a>
      </div>
    </div>
  );
}
